import { Alert } from '@/components/Alert';
import {
  JobListingAlertBanner,
  JobListingAlertsBannerProps,
} from '@/modules/JobListing/utils/JobListingTypes';

import Button from '@material-ui/core/Button';

const getJobAlertsBannerPropsMap = (): Record<
  JobListingAlertBanner,
  JobListingAlertsBannerProps
> => {
  return {
    'future-job-alert-create': {
      type: 'info',
      message:
        "Soon you'll be able to create job alerts for specific locations, radius, and minimum pay rates.",
      'data-testid': 'job-listing-alert-future-notice',
    },
    'select-search-criteria': {
      type: 'info',
      message: 'Select search criteria to receive a job alert by email when new jobs match.',
      'data-testid': 'job-listing-alert-select-search-criteria',
    },
    'select-subspeciality': {
      type: 'info',
      message: 'Please select a subspeciality of Medicine to save a job alert.',
      'data-testid': 'job-listing-alert-select-subspeciality',
    },
    'job-alert-create': {
      type: 'alert',
      message: 'Save this search to receive job alerts by email when new jobs match.',
      'data-testid': 'job-listing-alert-notice',
      buttonType: 'createAlert',
    },
    'manage-job-alert': {
      type: 'info',
      message: 'Your job search has been saved, and an alert has been set up.',
      'data-testid': 'job-listing-manage-alert-notice',
      buttonType: 'manageAlert',
    },
  };
};

interface JobAlertsBannerProps {
  jobListingAlertBanner: JobListingAlertBanner;
  onSave: () => void;
  onManage: () => void;
}

const JobAlertsBanner = ({ jobListingAlertBanner, onSave, onManage }: JobAlertsBannerProps) => {
  const alertBannerProps = getJobAlertsBannerPropsMap()[jobListingAlertBanner];

  const { type, message, buttonType } = alertBannerProps;

  const getAlertButton = () => {
    if (!buttonType) {
      return null;
    }

    return buttonType === 'createAlert' ? (
      <Button data-testid="job-listing-create-alert-button" onClick={onSave}>
        Save&nbsp;alert
      </Button>
    ) : (
      <Button data-testid="job-listing-manage-alert-button" onClick={onManage}>
        Manage your job alerts
      </Button>
    );
  };

  return (
    <Alert
      type={type}
      message={message}
      data-testid={alertBannerProps['data-testid']}
      callToActionChildren={getAlertButton()}
    />
  );
};

export default JobAlertsBanner;
